<template>
    <div class="adv-box">
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" :rowKey="record => record.id" :scroll="{ x: 500 }">
            <template slot="status" slot-scope="text, record, index">
                <a-switch
                    @change="handleSwitchEvent(record, index)"
                    :loading="record.switchLoading"
                    :checked-children="$t('web.show' /* 显示 */)"
                    :un-checked-children="$t('web.hide' /* 隐藏 */)"
                    :checked="record.status == 1"
                />
            </template>
            <template slot="action" slot-scope="text, record, index">
                <a-button @click="handleShowInfo(record)" type="primary" size="small">{{ $t('mobileConfig.advertising_content_management' /* 内容管理 */) }}</a-button>
            </template>
        </a-table>

        <adv-list ref="advList"></adv-list>
    </div>
</template>

<script>
import AdvList from '@/views/mobile-config/components/adv-list.vue';
export default {
    name: 'Advertising',
    components: {
        AdvList
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t('mobileConfig.advertising_position' /* 广告位置 */),
                    dataIndex: 'seat_name'
                },
                {
                    title: this.$t('mobileConfig.advertising_views' /* 浏览量 */),
                    dataIndex: 'hit',
                    align: 'center'
                },
                {
                    title: this.$t('web.status' /* 状态 */),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' }
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    scopedSlots: { customRender: 'action' },
                    align: 'center'
                }
            ],
            dataSource: [],
            visible: false,
            infoList: {}, //当前广告信息
            language: 'cn'
        };
    },
    created() {
        this.language = window.location.hash.match(/(cn|en)/g)[0];
        this.getList();
    },
    methods: {
        getList() {
            let data = {
                language: this.language
            };
            this.$request.get({ url: 'getAdList', data }).then(res => {
                res.data.data.forEach(v => {
                    v.switchLoading = false;
                });
                this.dataSource = res.data.data;
            });
        },
        handleSwitchEvent(record, index) {
            let data = {
                language: this.language,
                id: record.id
            };
            record.switchLoading = true;
            this.$request
                .post({ url: 'setAdSwitch', data })
                .then(res => {
                    if (res.code == 200) {
                        this.$set(this.dataSource[index], 'status', record.status == 1 ? 0 : 1);
                        this.$message.success(this.$t('web.operate_scuuess' /* 操作成功 */));
                        record.switchLoading = false;
                    }
                })
                .catch(err => {
                    record.switchLoading = false;
                });
        },
        handleShowInfo(record) {
            this.$refs.advList.showFun(record);
        }
    }
};
</script>

<style scoped lang="less"></style>
